import { BulkSpreadsheet, parseBool, parseInt10, type BulkColumn } from '../shared/BulkSpreadsheet';
import { licenseService } from '@kss/api';
import type { LicenseCreate } from '@kss/api';

const columns: BulkColumn<LicenseCreate>[] = [
  { key: 'planId', header: 'Plan ID', required: true },
  { key: 'startDate', header: 'Start date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'endDate', header: 'End date', dataType: 'date' },
  { key: 'status', header: 'Status', sample: 'Trial' },
  { key: 'maxUsers', header: 'Max users', dataType: 'integer', parse: parseInt10 as never, sample: '5' },
  { key: 'autoRenew', header: 'Auto renew', dataType: 'boolean', parse: parseBool as never, sample: 'false' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkLicense() {
  return (
    <BulkSpreadsheet<LicenseCreate> title="Bulk import licenses" entityLabel="license" backPath="/panel/licenses" columns={columns} module="License"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await licenseService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
